class dongXiHuQuMapTooltip {
  constructor(opt) {
    this.intervalHandle = null
    this.vm = opt.vm
    this.index = -1
    this.tooltipData = null
  }
  async dispatchLoopSelectAction(opt) {
    clearInterval(this.intervalHandle)
    await this.initToolTipData()
    this.initDom()
    if (this.tooltipData.length > 1) {
      this.startLoop()
    }
  }
  startLoop() {
    this.intervalHandle = setInterval(() => {
      this.initDom()
    }, 3000)
  }
  initDom() {
    this.removeOldToolTop() //移出之前的dom
    this.index = this.index + 1 >= this.tooltipData.length ? 0 : this.index + 1 //更新当前渲染的城市数据下标
    this.createToolTip(this.tooltipData[this.index]) //绘制dom
  }
  removeOldToolTop() {
    const el = this.vm.$el
    const oldNode = el.getElementsByClassName("dongXiHuQuMapTooltipPlugin")[0]
    if (oldNode) el.removeChild(oldNode)
  }
  createToolTip(mapData) {
    if (!mapData) return
    const wrapper = this.createWrapper(mapData)
    const head = this.createHead(mapData.name)
    const content = this.createContent(wrapper, mapData.data)
    wrapper.appendChild(head)
    wrapper.appendChild(content)
    this.vm.$el.appendChild(wrapper)
  }
  createBox() {
    const box1Style = { borderTop: "1px solid #4299FF", borderRight: "1px solid #4299FF", top: "0px", right: "0px" }
    const box2Style = { borderLeft: "1px solid #4299FF", borderBottom: "1px solid #4299FF", left: "0px", bottom: "0px" }
    const style = {
      width: "12px",
      height: "12px",
      background: "transparent",
      position: "absolute"
    }
    const box1 = this.createDom("div", Object.assign(box1Style, style))
    const box2 = this.createDom("div", Object.assign(box2Style, style))
    return [box1, box2]
  }
  createContent(wrapper, data) {
    const content = this.createDom("div", {
      // width: "100%",
      margin: "16px 0 0 14px",
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      fontWeight: "700",
      lineHeight: "20px",
      fontSize: "14px"
    })
    //计算最大value的长度
    const tempWrap = this.createDom("div", {
      opacity: 0,
      position: "absolute",
      left: "-999999px"
    })
    const maxNum = JSON.parse(JSON.stringify(data)).sort((a, b) => String(b.value).length - String(a.value).length)[0]
      .value
    const maxNumEL = this.createDom("span", { fontSize: "14px", fontWeight: "400" })
    maxNumEL.innerText = maxNum
    tempWrap.appendChild(maxNumEL)
    document.getElementsByTagName("body")[0].appendChild(tempWrap)
    window.getComputedStyle(maxNumEL)
    const maxWidth = maxNumEL.offsetWidth - 14
    document.getElementsByTagName("body")[0].removeChild(tempWrap)
    //计算最大key的长度
    const maxTitleLen = JSON.parse(JSON.stringify(data)).sort((a, b) => b.key.length - a.key.length)[0].key.length * 14
    data.forEach(data => {
      const itemEl = this.createDom("div", {
        marginBottom: "6px",
        display: "flex",
        flexDirection: "row",
        width: "100%"
      })
      const nameEl = this.createDom("p", {
        marginRight: "8px",
        width: maxTitleLen + "px",
        color: "rgb(203,189,241)",
        "text-align": "justify",
        "text-align-last": "justify"
      })
      const valueEl = this.createDom("p", {
        width: maxWidth + "px",
        color: "rgb(233,229,46)",
        textAlign: "right",
        marginRight: "8px"
      })
      const unitEl = this.createDom("span", { marginRight: "8px", color: "rgb(203,189,241)" })
      const { value, unit } = this.formateVal(data.value)
      nameEl.innerText = data.key
      valueEl.innerText = value
      unitEl.innerText = unit
      itemEl.appendChild(nameEl)
      itemEl.appendChild(valueEl)
      itemEl.appendChild(unitEl)
      content.appendChild(itemEl)
    })
    return content
  }
  formateVal(val) {
    let index = -Infinity
    for (let i = val.length - 1; i > -1; i--) {
      if (!isNaN(val[i]) && typeof Number(val[i]) === "number") {
        index = i
        break
      }
    }
    return {
      value: val.slice(0, index + 1),
      unit: val.slice(index + 1)
    }
  }
  createHead(name) {
    const head = this.createDom("div", {
      padding: "0 20px",
      width: "100%",
      "text-align": "center",
      "font-size": "16px",
      fontWeight: 700,
      color: "#ffffff",
      background: "linear-gradient(0deg,#0bbafb 0%, #4285ec 100%)",
      height: "30px",
      "border-radius": "2px"
    })
    const inner = this.createDom("span", {
      "line-height": "30px"
    })
    inner.innerText = name
    head.appendChild(inner)
    return head
  }
  createWrapper(mapData) {
    const maxKeySize = JSON.parse(JSON.stringify(mapData.data)).sort((a, b) => b.key.length - a.key.length)[0].key
      .length
    const el = this.vm.$refs.chartBox
    el.style.position = "relative"
    const elWidth = el.offsetWidth
    const wrapper = this.createDom("div", {
      padding: "10px",
      width: elWidth * 0.195 + (maxKeySize > 3 ? 1 : 0) + "px",
      border: "1px solid rgb(41,154,247)",
      borderRadius: "4px",
      backgroundColor: "rgb(8,14,75)",
      position: "absolute",
      right: "20px",
      top: "20px"
    })
    wrapper.className = "dongXiHuQuMapTooltipPlugin"
    return wrapper
  }
  createDom(dom, style) {
    const el = document.createElement(dom)
    Object.keys(style).forEach(styleName => {
      el.style[styleName] = style[styleName]
    })
    return el
  }
  async initToolTipData() {
    const toolTipData = await (this.vm.options?.restDataUrl?.length
      ? this.vm.instance.get(this.vm.options.restDataUrl)
      : Promise.resolve(null))
    const data = toolTipData?.data?.data?.content?.data
    if (data) {
      const filterK = ["建筑面积", "开放时间", "场馆地址", "经度", "纬度"]
      this.tooltipData = data.map(it => {
        it.data = it.data.filter(
          val => val.value.length !== 0 && val.value !== "暂无" && !filterK.find(it => it === val.key)
        )
        return it
      })
      console.log("this.tooltipData1 :>> ", this.tooltipData)
    } else {
      if (!this.tooltipData) {
        this.tooltipData = [
          {
            name: "东西湖区文化馆",
            data: [
              { key: "活动", value: "123212次" },
              { key: "资讯", value: "354个" },
              { key: "直录播", value: "341场" },
              { key: "场地", value: "34个" },
              { key: "资源", value: "34个" }
            ]
          },
          {
            name: "东湖区文化馆",
            data: [
              { key: "活动", value: "33次" },
              { key: "资讯", value: "455个" },
              { key: "资源", value: "44个" }
            ]
          },
          {
            name: "西湖区文化馆",
            data: [
              { key: "活动", value: "567次" },
              { key: "资讯", value: "765个" },
              { key: "直录播", value: "222场" },
              { key: "资源", value: "12个" }
            ]
          },
          {
            name: "湖区文化馆",
            data: [
              { key: "活动", value: "2346次" },
              { key: "资讯", value: "563个" },
              { key: "直录播", value: "1234场" },
              { key: "场地", value: "53个" },
              { key: "资源", value: "22个" }
            ]
          }
        ]
      }
    }
  }
}

export default {
  data() {
    return {
      dongXiHuQuMapTooltip: new dongXiHuQuMapTooltip({
        vm: this
      }),
      mapLoadTimer: null
    }
  },
  methods: {
    async dongXiHuQuMapTooltipPlugin(opt) {
      this.dongXiHuQuMapTooltip.dispatchLoopSelectAction(opt) //初始化提示框
      if (this.isBigScreenPreview() && this.options.updateTimer) {
        this.mapLoadTimer = setInterval(() => {
          this.dongXiHuQuMapTooltip.initToolTipData()
        }, this.options.updateTimer * 1000)
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.dongXiHuQuMapTooltip.intervalHandle)
    clearInterval(this.mapLoadTimer)
  },
  beforeUpdate() {
    clearInterval(this.dongXiHuQuMapTooltip.intervalHandle)
  }
}
